'use client';
import { configs } from '@/configs/configs';
import { useGoogleTagManager } from '@/lib/useGoogleTagManager';
import { initializeAuth } from 'auth';
import '../styles/global.css';
import { Spinner } from './components/Spinner';
import ToastContainer from './components/ToastContainer';

initializeAuth({
  apiUrl: configs.NEXT_PUBLIC_BACKEND_URL,
  appDomain: configs.NEXT_PUBLIC_APP_DOMAIN,
  hasRedirectAfterPasswordReset: true,
});

import { Suspense, type ReactNode } from 'react';

export default function RootLayout({
  children,
}: Readonly<{
  children: ReactNode;
}>) {
  const gtmId = configs.NEXT_PUBLIC_SSD_GTM_ID;
  useGoogleTagManager({ gtmId: configs.NEXT_PUBLIC_SSD_GTM_ID });

  return (
    <html lang="en">
      <body className="bg-gray-50">
        <Suspense fallback={<Spinner size="large" />}>
          <main>{children}</main>
        </Suspense>
        <ToastContainer />
      </body>
    </html>
  );
}
